import React from 'react';
import TitleText from '../atoms/TitleText';
import InfoText from '../atoms/InfoText';
// import Image from 'next/image';
import Chip from '../atoms/Chip';
import classNames from 'classnames';

type AvatarProps = {
  image?: string;
  title?: string;
  subTitle?: string | React.ReactNode;
  actions?: React.ReactNode;
  tag?: string;
  actionsFlag?: string[];
  className?: string;
  onClickLink?: (e: React.MouseEvent<HTMLDivElement>) => void;
  imageSize?: number;
  withoutBorder?: boolean;
  showNameInsteadOfImage?: boolean;
  dataTestId?: string;
};

export default function Avatar({
  image,
  title,
  subTitle,
  tag,
  actions,
  className,
  onClickLink,
  imageSize = 20,
  withoutBorder = false,
  showNameInsteadOfImage,
  dataTestId,
}: AvatarProps) {
  return (
    <div
      data-testid={dataTestId}
      className={classNames(
        'flex flex-col justify-between items-center lg:flex-row',
        className
      )}
    >
      {/* ------------ Image */}
      <div
        className={classNames(
          'flex flex-col items-center lg:flex-row',
          !!title && 'gap-4'
        )}
        data-testid="avatar-content-wrapper"
      >
        {(image || showNameInsteadOfImage) && (
          <div
            className={classNames(
              `w-${imageSize} h-${imageSize} min-w-${imageSize} min-h-${imageSize} rounded-[50%] p-0.5 flex items-center justify-center border-light-success border-2 dark:border-dark-button-bg-primary relative`,
              withoutBorder && 'border-none',
              showNameInsteadOfImage && 'bg-light-button-hover'
            )}
          >
            {image && !showNameInsteadOfImage && (
              <img
                alt="avatar"
                src={image}
                className="rounded-[50%] !w-full !h-full  object-cover"

                // loading="lazy"
              />
            )}

            {showNameInsteadOfImage && !image && (
              <InfoText
                className="!w-full !h-full object-cover flex items-center justify-center !text-light-surface-primary"
                text={`${title?.split(' ')[0]?.charAt(0)} ${title
                  ?.split(' ')[1]
                  ?.charAt(0)}`}
                size="lg"
              />
            )}
          </div>
        )}

        {/* ------------ Title and sub title */}
        <div
          className={classNames(
            'max-w-[600px] flex flex-col justify-center items-center space-y-2 lg:items-start lg:space-y-1',
            onClickLink && 'cursor-pointer hover:opacity-80'
          )}
          {...(onClickLink && { role: 'button', onClick: onClickLink })}
          data-testid="avatar-text-container"
        >
          <div className="flex items-center space-x-2 lg:text-center">
            {title && <TitleText size="xl" text={title} />}

            {tag && (
              <Chip type="primary" data-testid="avatar-tag">
                {tag}
              </Chip>
            )}
          </div>

          {subTitle &&
            (typeof subTitle === 'string' ? (
              <InfoText
                text={subTitle}
                className="text-center lg:text-start"
                data-testid="avatar-subtitle"
              />
            ) : (
              <div data-testid="avatar-custom-subtitle">{subTitle}</div>
            ))}
        </div>
      </div>

      {/* ------------ Actions */}
      {actions && <div data-testid="avatar-actions">{actions}</div>}
    </div>
  );
}
